export enum ContentLanguage {
  English = 0,
  Danish = 1
}

/**
 * The API registers JsonStringEnumConverter globally, so enums come back as
 * their names ("English"/"Danish") while the client's dropdown options and
 * request payloads use the numeric values. Normalises either form to the
 * numeric enum; returns null for "All" (unset) or anything unrecognised.
 */
export function toContentLanguage(
  value: ContentLanguage | string | number | null | undefined,
): ContentLanguage | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  if (typeof value === 'number') {
    return value in ContentLanguage ? (value as ContentLanguage) : null;
  }
  const byName = (ContentLanguage as Record<string, unknown>)[value];
  if (typeof byName === 'number') {
    return byName as ContentLanguage;
  }
  const asNumber = Number(value);
  return Number.isInteger(asNumber) && asNumber in ContentLanguage
    ? (asNumber as ContentLanguage)
    : null;
}
